<template>
  <v-card>
    <!-- {{editItem}} -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Passenger</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editProjectForm" v-model="valid" lazy-validation>
      
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex md6 class="pr-1">
              <v-menu
                v-model="contractDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editItem.contract_date"
                    label="Contract date *"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editItem.contract_date"
                  @input="contractDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6>
            <v-autocomplete
                label="Select agent *"
                v-model="editItem.agent_id"
                :items="agentsTV"
                hide-details
                hide-selected
                item-text="text"
                item-value="value"
                outline
                required
                :rules="requiredRules"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                label="Applied Country *"
                v-model="editItem.applied_country"
                :items="COUNTRIES"
                hide-details
                hide-selected
                outline
                required
                :rules="requiredRules"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex md6 pl-1>
              <v-text-field
                outline
                label="Profession *"
                v-model="editItem.profession"
                required
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex md4>
              <v-text-field
                outline
                label="Candidate Name *"
                required
                v-model="editItem.name"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
            <v-flex md4 pl-1>
              <v-text-field
                outline
                label="Father's Name *"
                required
                v-model="editItem.father_name"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
            <v-flex md4 pl-1>
              <v-text-field
                outline
                label="Mother's Name *"
                required
                v-model="editItem.mother_name"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        
          <v-flex xs12> Present Address: </v-flex>
          <v-flex xs12>
            <v-layout>
              <v-flex md3>
                <v-autocomplete
                  label="District *"
                  v-model="editItem.present_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS *"
                  v-model="editItem.present_upazila"
                  :items="upazilaTV(editItem.present_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O *"
                  v-model="editItem.present_union"
                  :items="unionTV(editItem.present_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill *"
                  required
                  v-model="editItem.present_village"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12> Permanent Address: </v-flex>
          <v-flex xs12>
            <v-layout pb-1>
              <v-flex md3>              
                  <!-- clearable
                  @click:clear="editItem.permanent_district = 'p'" -->
                <v-autocomplete
                  label="District"
                  v-model="editItem.permanent_district"
                  :items="districtTV()"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="PS"
                  v-model="editItem.permanent_upazila"
                  :items="upazilaTV(editItem.permanent_district)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-autocomplete
                  label="P.O"
                  v-model="editItem.permanent_union"
                  :items="unionTV(editItem.permanent_upazila)"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md3 pl-1>
                <v-text-field
                  outline
                  label="Vill"
                  v-model="editItem.permanent_village"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout pb-1>
              <v-flex md4 pr-1>
                <v-text-field
                  outline
                  label="Passport number *"
                  required
                  v-model="editItem.passport_number"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pr-1>
                <v-menu
                  v-model="passportIssueDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editItem.passport_issue_date"
                      label="Issue date *"
                      readonly
                      outline
                      required
                      :rules="requiredRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editItem.passport_issue_date"
                    @input="passportIssueDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md4>
                <v-menu
                  v-model="passportExpDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editItem.passport_exp_date"
                      label="Exp date *"
                      readonly
                      outline
                      required
                      :rules="requiredRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editItem.passport_exp_date"
                    @input="passportExpDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md6 pr-1>
                <v-menu
                  v-model="dobDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editItem.dob"
                      label="Date of birth *"
                      readonly
                      outline
                      v-on="on"
                      required
                      :rules="requiredRules"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editItem.dob"
                    @input="dobDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field 
                  outline label="Age *" v-model="editItem.age"
                  required
                  :rules="requiredRules"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex md4 pr-1>
                <v-text-field
                  outline
                  label="NID Number *"
                  v-model="editItem.nid_number"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex md4 pr-1>
                <v-text-field
                  outline
                  label="Birth Cert. Number *"
                  v-model="editItem.birth_cert_number"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  label="Nationality *"
                  v-model="editItem.nationality"
                  :items="NATIONALITIES"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-4>
              <v-flex md6 pr-1>
                <v-autocomplete
                  label="Gender *"
                  v-model="editItem.gender"
                  :items="GENDERS"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  label="Religion *"
                  v-model="editItem.religion"
                  :items="getTV(RELIGIONS)"
                  hide-details
                  hide-selected
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-1>
              <v-flex md4 pr-1>
                <v-autocomplete
                  label="Marital Status"
                  v-model="editItem.marital_status"
                  :items="getTV(MARITAL_STATUSES)"
                  hide-details
                  hide-selected
                  outline
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs4 pr-1>
                <v-text-field
                  outline
                  label="Height"
                  v-model="editItem.height"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  outline
                  label="Weight"
                  v-model="editItem.weight"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap pb-1>
              <v-flex md6 pr-1>
                <v-autocomplete
                  label="Expert in Language *"
                  v-model="editItem.language_proficiency"
                  :items="getTV(LANGUAGES, {textField:'name', valueField: 'name', isDeselect: false})"
                  hide-details
                  hide-selected
                  outline
                  multiple
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    outline
                    label="Educational Qualification *"
                    v-model="editItem.educational_qualification"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 pr-1>
                <v-text-field
                    outline
                    label="Work Exp *"
                    v-model="editItem.working_experience"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    outline
                    label="Type of Work Exp *"
                    v-model="editItem.working_experience_type"
                    required
                    :rules="requiredRules"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6 pr-1>
                <v-text-field
                    outline
                    label="Mobile Number"
                    v-model="editItem.mobile"
                  ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    outline
                    label="Family Mobile Number"
                    v-model="editItem.family_mobile_number"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-textarea v-model="editItem.notes" outline label="Notes"></v-textarea>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  GENDERS,
  MEDICAL_STATUSES,
  FINGER_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  COUNTRIES,
  NATIONALITIES,
  RELIGIONS,
  MARITAL_STATUSES,
  LANGUAGES,
} from "../../mdsir/const";
import { getTV, removeEmptyProps, districtTV, upazilaTV, unionTV } from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "agents", "employers"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,

      contractDateMenu: false,
      dobDateMenu: false,
      medicalDateMenu: false,
      mofaDateMenu: false,
      trainingStartDateMenu: false,
      trainingEndDateMenu: false,
      visaIssueDateMenu: false,
      flightDateMenu: false,
      COUNTRIES: COUNTRIES,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      MARITAL_STATUSES: MARITAL_STATUSES,
      LANGUAGES: LANGUAGES,
      passportIssueDateMenu: false,
      passportExpDateMenu: false,
    };
  },
  computed: {
    medicalStatuses() {
      return getTV(MEDICAL_STATUSES);
    },
    fingerStatuses() {
      return getTV(FINGER_STATUSES);
    },
    visaTypes() {
      return getTV(VISA_TYPES);
    },
    serviceTypes() {
      return getTV(SERVICE_TYPES);
    },
    agentsTV() {
      return getTV(this.agents, { textField: "name", valueField: "id" });
    },
    employersTV() {
      return getTV(this.employers, { textField: "name", valueField: "id" });
    },
    projectOwnersTV() {
      return getTV(PROJECT_OWNER, { isDeselect: false });
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editProjectForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editProjectForm.reset();
    },
    resetValidation() {
      this.$refs.editProjectForm.resetValidation();
    },
    editItemDo() {
      if (this.$refs.editProjectForm.validate()) {
        this.actionButtonClicked = true;
        this.put(
          "/project",
          removeEmptyProps(this.editItem, [
            "contract_date",
            "dob",
            "visa_issue_date",
            "flight_date",
            "medical_date",
            "mofa_date",
            "training_start_date",
            "training_end_date"
          ])
        ).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
